import { constants } from '..';

const { SUPPORTED_PROS } = constants;

export const getSupportedProsLabel = (conjunction: string): string =>
    `${SUPPORTED_PROS.slice(0, SUPPORTED_PROS.length - 1).join(
        ', ',
    )} ${conjunction} ${SUPPORTED_PROS[SUPPORTED_PROS.length - 1]}`;
